import { render, staticRenderFns } from "./ExaminationDetailPage.vue?vue&type=template&id=28f2568a&scoped=true&"
import script from "./ExaminationDetailPage.vue?vue&type=script&lang=js&"
export * from "./ExaminationDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationDetailPage.vue?vue&type=style&index=0&id=28f2568a&prod&lang=scss&"
import style1 from "./ExaminationDetailPage.vue?vue&type=style&index=1&id=28f2568a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2568a",
  null
  
)

export default component.exports